export const loadPage = () => {
  document.body.classList.add("loaded");
  console.log("Loaded");
};
